module.exports = __webpack_public_path__ + "static/media/logo_no_text.e71571fb.png";